export default "__VITE_ASSET__BC8lyC5b__"